import React, { FC } from 'react';
import { Grid, Box, Typography, Container } from '@mui/material';

import { useTributes } from '@modules/Tributes/hooks/useTributes';
import ActionBar from '@modules/Tributes/components/ActionBar';
import CreditCard from '@modules/Tributes/components/CreditCard';
import { UserContext } from '@modules/Users/contexts';
import { TributeCard } from '@modules/Tributes/components/TributeCard';
import { clearKeys } from '@cvt/hooks/form/useFormPersist';

import { DashboardHeader } from './DashboardHeader';


export const Dashboard: FC = () => {
  const { tributes = [] } = useTributes();
  const { user } = React.useContext(UserContext);
  const publishedCount = tributes.filter(tribute => tribute.status === 'published').length;
  const inProgressCount = tributes.filter(tribute => tribute.status === 'draft').length;
  const unusedCount = tributes.filter(tribute => tribute.status === 'unused').length;
  const unusedCredits = React.useMemo(() => user?.credits || [], [user?.credits]);
  const availableCredits = unusedCredits.length;

  const handleCreateLGCYClick = () => {
    clearKeys(['pet-details', 'tribute-story']);
  };

  return (
    <Container maxWidth={false} disableGutters>
      <DashboardHeader tributes={tributes} unusedCredits={unusedCredits} />

      <Box
        sx={{
          py: 4,
          px: { xs: 2, xl: 0 },
        }}
        maxWidth="lg"
        marginLeft="auto"
        marginRight="auto"
      >

        <Box sx={{ mb: 4 }}>
          <ActionBar
            publishedCount={publishedCount}
            inProgressCount={inProgressCount}
            unusedCount={unusedCount}
            availableCredits={availableCredits}
            onCreateLGCYClick={handleCreateLGCYClick}
          />
        </Box>

        {tributes.length === 0 ? (
          <Typography variant="body1" color="text.secondary" sx={{ mt: 4, textAlign: 'center' }}>
            No tributes found. Create your first tribute to get started.
          </Typography>
        ) : (
          <Grid>
            <Grid>
              <Typography variant="h2" component="h1" sx={{ fontWeight: 600, color: 'text.primary', mb: 2 }}>
                  Your LGCYs
              </Typography>
            </Grid>
            <Grid container spacing={4}>
              {tributes.map((tribute: Tributes.Tribute) => {
                return (
                  <TributeCard
                    key={tribute.id}
                    tribute={tribute}
                  />
                );
              })}
            </Grid>
          </Grid>
        )}
        {unusedCredits.length > 0 && (
          <Box sx={{ mt: 8 }}>
            <Typography variant="h2" component="h1" sx={{ fontWeight: 600, color: 'text.primary', mt: 2 }}>
                Available Credits
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                These credits can be used to create new LGCYs or gifted to someone else.
            </Typography>
            <Grid container spacing={4} sx={{ mt: 1 }}>
              {unusedCredits.map((credit: Tributes.AvailableCredit) => (
                <CreditCard
                  key={credit.id}
                  credit={credit}
                  onCreateLGCYClick={handleCreateLGCYClick}
                />
              ))}
            </Grid>
          </Box>
        )}
      </Box>
    </Container>
  );
};
